import { render, staticRenderFns } from "./wf-formattable-text-area-edit.vue?vue&type=template&id=5d87ecdf&scoped=true&"
import script from "./wf-formattable-text-area-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-formattable-text-area-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-formattable-text-area-edit.vue?vue&type=style&index=0&id=5d87ecdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d87ecdf",
  null
  
)

export default component.exports